module.exports = __webpack_public_path__ + "static/media/wrl-vir-logo@2x.4ba17a85.png";


//////////////////
// WEBPACK FOOTER
// ./html/assets/images/wrl-vir-logo@2x.png
// module id = 1222
// module chunks = 0